import { IContentChannel } from "@nendaTypes/NendaTypes";
import React, { useMemo } from "react";
import AssetPreviewDialog, { isPreviewableAsset } from "./AssetPreviewDialog";

export function isChannelPreviewable(channel: IContentChannel): boolean {
  if (!channel) return false;
  if (!channel.isPublic) return false;
  return channel.playlist.some(isPreviewableAsset);
}

interface PreviewProps {
  isOpen: boolean;
  contentChannel: IContentChannel;
  onClose: () => void;
  onError?: (error: Error) => void;
}

const Preview: React.FC<PreviewProps> = ({
  isOpen,
  contentChannel,
  onClose,
  onError,
}) => {
  const { assetId, unavailableReason } = useMemo(() => {
    if (!isOpen) return {};
    if (contentChannel.playlist.length === 0) {
      return { unavailableReason: "Content channel is empty" };
    }
    const playable = contentChannel.playlist.filter(isPreviewableAsset);
    if (playable.length === 0) {
      return { unavailableReason: "Preview not supported for this content" };
    }
    return {
      assetId: playable[Math.floor(Math.random() * playable.length)].locator,
    };
  }, [contentChannel._id, isOpen]);

  return (
    <AssetPreviewDialog
      isOpen={isOpen}
      assetId={assetId}
      title={contentChannel.name}
      unavailableReason={unavailableReason}
      onClose={onClose}
      onError={onError}
    />
  );
};

export default Preview;
